module.exports = __webpack_public_path__ + "static/Brightside Health-bcf03b2c9d3f0898dbbc7ca327800e82.jpg";